<template>
  <!-- Totals of the whole filtered set, not of the page shown. -->
  <dl class="tw:grid tw:grid-cols-2 tw:sm:grid-cols-3 tw:lg:grid-cols-6 tw:gap-3 tw:mb-4">
    <div
      v-for="figure in figures"
      :key="figure.key"
      class="tw:rounded-md tw:border tw:border-zinc-200 tw:bg-white tw:px-3 tw:py-2"
    >
      <dt class="tw:text-xs tw:text-zinc-500">{{ $t(figure.label) }}</dt>
      <dd class="tw:mb-0 tw:text-lg tw:font-semibold tw:tabular-nums">{{ formatNumber(totals[figure.key]) }}</dd>
    </div>
  </dl>
</template>

<script setup>
import { formatNumber } from './format'

defineProps({
  totals: {
    type: Object,
    required: true,
  },
})

const figures = [
  { key: 'invocations', label: 'Calls' },
  { key: 'steps', label: 'Steps' },
  { key: 'input_tokens', label: 'Input tokens' },
  { key: 'output_tokens', label: 'Output tokens' },
  { key: 'cache_read_input_tokens', label: 'Cached input tokens' },
  { key: 'reasoning_tokens', label: 'Reasoning tokens' },
]
</script>
